












































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { createDigitsArr } from '@/tools/counters';
import { pad } from '@/filters/pad';

@Component({
  filters: {
    pad
  }
})
export default class HeatCounterSvg extends Vue {
  @Prop({ required: true })
  private Digits!: string;

  @Prop({ required: true })
  private Unit!: string;

  @Prop({ default: 'м³' })
  private Metric!: string;

  private readonly DigitsArr: Array<string> = createDigitsArr(this.Digits);
}
